import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from "@dnd-kit/sortable";
import { ReactNode } from "react";
import cx from "classnames";

import Typography from "ds/components/Typography";
import Card from "ds/components/Card";

import styles from "./styles.module.css";

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

type DragDropListDroppableContainerProps<T = string> = {
  children: ReactNode;
  id: string;
  items: T[];
  title?: ReactNode;
  className?: string;
  disabled?: boolean;
  hasCardWrapper?: boolean;
};

const DragDropListDroppableContainer = ({
  children,
  id,
  items,
  title,
  className,
  disabled,
  hasCardWrapper,
}: DragDropListDroppableContainerProps) => {
  const { setNodeRef, attributes } = useSortable({
    id,
    data: {
      type: "container",
      children: items,
    },
    disabled: {
      draggable: !!disabled,
      droppable: !!disabled,
    },
    animateLayoutChanges,
  });

  const Wrapper = hasCardWrapper ? Card : "div";

  return (
    <Wrapper
      variant={hasCardWrapper ? "secondary" : undefined}
      className={cx(styles.droppableWrapper, className)}
    >
      <div {...attributes} ref={setNodeRef} className={styles.droppableZone}>
        {title && typeof title === "string" && (
          <Typography
            variant="p-t8"
            tag="div"
            color="secondary"
            transform="uppercase"
            margin="0 0 medium 0"
          >
            {title}
          </Typography>
        )}
        {title && typeof title !== "string" && title}
        <div className={cx(disabled && styles.droppableContainerDisabled)}>{children}</div>
      </div>
    </Wrapper>
  );
};

export default DragDropListDroppableContainer;
